const TUS_CONFIG = {
  resume: true,
  chunkSize: 100000022,
  limit: 20,
  removeFingerprintOnSuccess: true,
}

export default TUS_CONFIG
